import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class FinancialService {
  constructor(private readonly http: HttpClient) {}

  getFinanceBudget(projectId: any, offSet?: any, end?: any, onlyActive?: any) {
    let params = `project_id=${projectId}`;
    if (offSet !== undefined && end !== undefined) {
      params += `&offset=${offSet}&end=${end}`;
    }
    if (onlyActive !== undefined) {
      params += `&only_active=${onlyActive}`;
    }
    return this.http.get(`finance/budgets/?${params}`);
  }

  consumeInternalFunds(payload: any = {}) {
    return this.http.post("finance/budgets/consume-internal-funds/", payload);
  }

  getFinanceSpend(projectId: any, month: any = "", offSet?: any, end?: any) {
    const params = `project_id=${projectId}&month=${month}&offset=${offSet}&end=${end}`;
    return this.http.get(`finance/spends/?${params}`);
  }

  getBudgetConsumption(budget: any) {
    return this.http.get(`finance/budgets/consumption/?budget=${budget}`);
  }

  getCostPoolTaxanomy() {
    return this.http.get("metrics/cost-pool-taxonomy/details/");
  }

  getOuGdpList() {
    return this.http.get("vendors/names/");
  }

  getVendorDetails(id: any) {
    return this.http.get(`vendors/${id}/`);
  }

  getEnterpriseDetails() {
    return this.http.get("vendors/vendor-enterprise/");
  }

  getUserList() {
    return this.http.get("users/user-list/");
  }

  getExecutionTypeList() {
    return this.http.get("base_value/?type=project_execution_type");
  }

  getSpendTypes() {
    return this.http.get("base_value/?type=project_spend_type");
  }

  addFinanceBudget(data: any) {
    return this.http.post("finance/budgets/", data);
  }

  editFinanceBudget(budgetId: any, data: any) {
    return this.http.patch(`finance/budgets/${budgetId}/`, data);
  }

  editProjectDetail(projectId: any, data: any) {
    return this.http.patch(`projects/${projectId}/`, data);
  }

  deleteFinanceBudget(budgetId: any) {
    return this.http.delete(`finance/budgets/${budgetId}/`);
  }

  addFinanceSpend(data: any) {
    return this.http.post("finance/spends/", data);
  }

  downloadInvoiceDoc(queryParams: string) {
    return this.http.get(`finance/spends/download_document/?${queryParams}`);
  }

  editFinanceSpend(spendId: any, data: any) {
    return this.http.patch(`finance/spends/${spendId}/`, data);
  }

  deleteFinanceSpend(spendId: any) {
    return this.http.delete(`finance/spends/${spendId}/`);
  }

  getProjectPulse(projectId: any) {
    return this.http.get(`nps/pulses/?project=${projectId}`);
  }

  getPOsData(queryParams: any) {
    return this.http.get(`finance/purchase-orders/?${queryParams}`);
  }

  addPO(formData: any) {
    return this.http.post("finance/purchase-orders/", formData);
  }

  downloadPODoc(queryParams: string) {
    return this.http.get(
      `finance/purchase-orders/download_document/?${queryParams}`,
      { responseType: "blob" }
    );
  }

  getPONames(queryParams: string) {
    return this.http.get(`finance/purchase-orders/names/${queryParams}`);
  }

  getCostHead() {
    return this.http.get(`base_value/?type=budget_cost_head`);
  }

  getCostType() {
    return this.http.get(`base_value/?type=budget_cost_type`);
  }

  getCostOrigin() {
    return this.http.get(`base_value/?type=budget_cost_origin`);
  }

  getCostHeadCostTypeMapping() {
    return this.http.get(`finance/budgets/head-type-mapping/`);
  }

  getBugetsInsigtht(queryParams: any) {
    return this.http.get(`finance/budgets/insights/?${queryParams}`);
  }

  getCalendarViewData(projectId: any) {
    return this.http.get(
      `finance/budgets/calendar-view?project_id=${projectId}`
    );
  }

  createInvoiceWithAI(data: any) {
    return this.http.post(`finance/spends/with-ai/`, data);
  }

  createPurchaseOrderWithAI(data: any) {
    return this.http.post(`finance/purchase-orders/with-ai/`, data);
  }

  getBudgetSetupInitiatives(queryParam: any, moduleName: string = '') {
    return this.http.get("finance/budget-map?" + queryParam + `&module=${moduleName}`);
  }

  getBudgetSetupApplicatinoView(queryParam: any, moduleName: string = '') {
    return this.http.get("finance/budget-map/application-view?" + queryParam + `&module=${moduleName}`);
  }

  getCloudProviderTypes() {
    return this.http.get("base_value/?type=cloud_cost_providers");
  }

  uploadCloudUsage(payload: any) {
    return this.http.post(`billing/import-excel`, payload);
  }

  getFinancialSummary(queryParams:any){
    return this.http.get("finance/spends/financial-summary?" + queryParams);
  }
}
